import Link from 'components/Link';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TableLink: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    text,
    to = ''
}) => <Link className={`${className} ${styles.tableLink}`} testId={testId} text={text} to={to} />;

export default TableLink;
